import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "room",
  "use": "room-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"room\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 6a1 1 0 00-1 1v1H7a1 1 0 100 2h1v4H7a1 1 0 100 2h1v1a1 1 0 102 0v-1h4v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1v-4h1a1 1 0 100-2h-1V7a1 1 0 10-2 0v1h-4V7a1 1 0 00-1-1zm5 8v-4h-4v4h4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol